import { render, staticRenderFns } from "./Manage-Unit-Settings.vue?vue&type=template&id=4483c492"
import script from "./Manage-Unit-Settings.vue?vue&type=script&lang=js"
export * from "./Manage-Unit-Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports